import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useEffect } from 'react';
import { useEvent, useUnit } from 'effector-react';
import ContentContainer from './components/ContentContainer/ContentContainer.jsx';
import { $globalStore, getRawDataFx } from './models/globalModel/index.js';
import {
  $authStatus,
  $userConfirmed,
  $userInfo,
  getCurrentUserFx,
  setAuthStatusEv,
} from './models/authModel/index.js';
import { cookies } from './api/axiosInstance.js';
import { getProjectFx } from './models/viewProjectModel/index.js';
import { getOrganizationFx } from './models/viewSubjectModel/index.js';
import { getDictionariesFx } from './models/dictionariesModel/effects.js';
import { getOverviewDataFx } from './models/overviewModel/index.js';
import { getNMPDataDupFx, getNMPDataFx } from './models/mgpModel/index.js';
import { getAnalyticsDataFx } from './models/organizationsModel/index.js';
import UserAgreementModal from './components/UserAgreementModal/UserAgreementModal.jsx';
import GlobalPasswordChangeModal from './components/GlobalPassChangeModal/GlobalPassChangeModal.jsx';

function App() {
  const location = useLocation();
  const navigate = useNavigate();

  const globalStore = useUnit($globalStore);
  const isUserLoading = useUnit(getCurrentUserFx.pending);
  const isGlobalLoading = useUnit(getRawDataFx.pending);
  const isProjectLoading = useUnit(getProjectFx.pending);
  const isOrganizationLoading = useUnit(getOrganizationFx.pending);
  const isOverviewLoading = useUnit(getOverviewDataFx.pending);
  const isNMPLoading = useUnit(getNMPDataFx.pending);
  const isNMPLoadingDup = useUnit(getNMPDataDupFx.pending);
  const analyticsLoading = useUnit(getAnalyticsDataFx.pending);

  const isLoading =
    isUserLoading ||
    isGlobalLoading ||
    isProjectLoading ||
    isOrganizationLoading ||
    isOverviewLoading ||
    isNMPLoading ||
    isNMPLoadingDup ||
    analyticsLoading;

  const authStatus = useUnit($authStatus);
  const curUser = useUnit($userInfo);
  const userConfirmed = useUnit($userConfirmed);
  const setAuth = useEvent(setAuthStatusEv);

  useEffect(() => {
    if (authStatus && !curUser.role) {
      getCurrentUserFx();
    }
  }, [authStatus, curUser]);

  useEffect(() => {
    if (
      authStatus &&
      curUser.role === 'rpp_bc' &&
      location.pathname !== '/polls-results'
    ) {
      navigate('/polls-results');
    }
    if (
      location.pathname === '/' &&
      authStatus &&
      curUser.role &&
      !['potential_investor', 'vtp', 'fundraiser', 'investor', 'mgp'].includes(
        curUser.role
      )
    ) {
      navigate('/dashboard');
    } else if (
      ['/', '/dashboard'].includes(location.pathname) &&
      authStatus &&
      curUser.role &&
      curUser.role === 'mgp'
    ) {
      navigate('/mgp-registry');
    } else if (
      ['/', '/dashboard'].includes(location.pathname) &&
      authStatus &&
      curUser.role &&
      (curUser.role === 'potential_investor' ||
        curUser.role === 'vtp' ||
        curUser.role === 'fundraiser')
    ) {
      navigate('/invest-requests');
    } else if (
      ['/', '/dashboard'].includes(location.pathname) &&
      authStatus &&
      curUser.role === 'investor'
    ) {
      if (
        curUser.gov_id === '110340014141' ||
        curUser.gov_id === '220340002110'
      ) {
        navigate('/my-profile');
      } else {
        navigate('/edit-project');
      }
    }
  }, [location, curUser, authStatus]);

  useEffect(() => {
    if (
      !location.pathname.includes('foreign-investments') &&
      Object.keys(globalStore).length === 0 &&
      curUser.role &&
      curUser?.user_agreement_confirmed === true
    ) {
      getRawDataFx();
      getDictionariesFx();
    }
  }, [curUser]);

  useEffect(() => {
    if (!location.pathname.includes('public')) {
      if (!authStatus) {
        const token = cookies.get('access_token');
        if (!token && !location.pathname.includes('foreign-investments')) {
          navigate('/login');
        } else {
          setAuth(true);
        }
      }
    }
  }, [authStatus, location.pathname]);

  return (
    <>
      <GlobalPasswordChangeModal />
      <Spin spinning={isLoading} tip="Загружаем данные..." size="large">
        {Object.hasOwn(curUser, 'user_agreement_confirmed') &&
          curUser?.user_agreement_confirmed === false && <UserAgreementModal />}
        {(curUser?.id && userConfirmed) ||
        location.pathname?.includes('public') ? (
          <ContentContainer>
            <Outlet />
          </ContentContainer>
        ) : curUser?.id && !userConfirmed ? (
          <div style={{ textAlign: 'center', marginTop: 100 }}>
            <h2>Подтвердите регистрацию на почте</h2>
          </div>
        ) : (
          <div style={{ height: '100dvh', width: '100dvw' }} />
        )}
      </Spin>
    </>
  );
}

export default App;
